export default "/assets/website/images/favorite_empty_icon.svg?b828ffd935d0386bcd573a5b923f84ae";